import React, { FC, useState, useEffect } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import style from './InputCopyToClipboard.module.scss'
import classnames from 'classnames'

export interface InputCopyToClipboardProps {
  link: string
  onCopied?(): void
  className?: string
  inputClassName?: string
  label?: string | React.ReactNode | null
  id: string
  disabled?: boolean
  inputType?: string
  dataBdd?: string
  textCopiedMsg?: string
  placeholderText?: string
  tabIndex?: number
}

const _InputCopyToClipboard: FC<InputCopyToClipboardProps> = ({
  link, onCopied, className, inputClassName,
  label = null, id, disabled = false,
  inputType = 'text', dataBdd = 'copy-to-clipboard',
  textCopiedMsg = 'Copied to clipboard', placeholderText,
  tabIndex = 0
}) => {

  const [ copied, setCopied ] = useState(false)
  const [ isTransitioning, setIsTransitioning] = useState(false)

  const handleCopied = () => {

    setCopied(true)
    if (onCopied) onCopied()

  }

  useEffect(() => {

    if (!copied) return

    const timer = setTimeout(() => {

      setIsTransitioning(true)
      setCopied(false)

    }, 2000)

    return () => clearTimeout(timer)

  }, [ copied ])

  const onTransitionEnd = () => {
    if (!copied) {
      setIsTransitioning(false)
    }
  }

  return <div
    className={classnames(style['CopyToClipboard'], className)}
    data-bdd={dataBdd}
  >
    {
      label &&
      <label htmlFor={id}>{ label }</label>
    }
    <CopyToClipboard
      text={link}
      onCopy={handleCopied}
      className={classnames(style['CopyToClipboard-Input'], inputClassName)}
      data-bdd={`${dataBdd}-trigger`}
    >
      <input type={inputType} defaultValue={link} onChange={(e) => e.preventDefault() } readOnly id={id} disabled={disabled} placeholder={placeholderText} tabIndex={tabIndex} />
    </CopyToClipboard>
    <p
      onTransitionEnd={onTransitionEnd}
      className={classnames(style['CopyToClipboard-CopiedMessage'], { 
        [style['CopyToClipboard-CopiedMessage--show']]: copied,
        [style['CopyToClipboard-CopiedMessage--transitioning']]: isTransitioning
      })}
      data-bdd='copy-to-clipboard-confirm'
    >{ textCopiedMsg }</p>
  </div>

}

export default _InputCopyToClipboard
